module.exports = __webpack_public_path__ + "img/hest_fissen.8f81b010.jpg";